<app-retail-store-form-wrapper
  data-testid="retail-store-edit-container"
  #formWrapper
  [config]="config"
  [editMode]="true"
  [viewMode]="false"
></app-retail-store-form-wrapper>